export default function objectAssignDeep(target, source, reviver = objectAssignDeep) {
  if (source && typeof source === 'object' && !Array.isArray(source)) {
    if (!target) return source;
    for (const key of Object.keys(source)) {
      target[key] = reviver(target[key], source[key]);
    }
    return target;
  }
  return source;
}



// WEBPACK FOOTER //
// ./utils/object-assign-deep.jsx